module.exports = __webpack_public_path__ + "static/img/not_have.01994f30.png";